import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

// « Reel recouvert » (façon Facebook) : la vidéo — sponsorisée ou organique — se met en pause dès qu'une surface la cache
// (chat plein écran mobile, formulaire de prospects, app en arrière-plan / écran verrouillé) et reprend à la même position.
export const isPageHidden = () => typeof document !== "undefined" && document.visibilityState === "hidden";

export const reelCovered = ({ pageHidden = false, chatOpen = false, isMobile = false, dialogOpen = false } = {}) =>
  !!(pageHidden || dialogOpen || (isMobile && chatOpen));

export const usePageHidden = () => {
  const [hidden, setHidden] = useState(isPageHidden);
  useEffect(() => {
    const onVis = () => setHidden(isPageHidden());
    const onHide = () => setHidden(true);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("pagehide", onHide);
    window.addEventListener("pageshow", onVis);
    let sub = null;
    if (Capacitor?.isNativePlatform?.()) {
      // Android : le WebView ne signale pas toujours la mise en arrière-plan → on écoute aussi l'état natif.
      try { sub = App.addListener("appStateChange", ({ isActive }) => setHidden(!isActive)); } catch { sub = null; }
    }
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("pagehide", onHide);
      window.removeEventListener("pageshow", onVis);
      try { (sub?.remove ? sub.remove() : sub?.then?.((h) => h?.remove?.())); } catch { /* noop */ }
    };
  }, []);
  return hidden;
};
